import React, { Component, Fragment, createRef } from 'react'
import swal from 'sweetalert';
import { postEval } from '../../services/api-services/evaluasi-api';

export default class PertanyaanDosen extends Component {

    constructor(props) {
        super(props)
        this.closeModal = createRef();
        this.state = {
            detailModal: [],
            dataAnswer: []
        }
    }

    detailModal = (data) => {
        this.setState({
            detailModal: data,
        })
    }

    handleInput = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    };

    handleAnswer = (event) => {
        const bobot = event.target.value
        const id = event.target.name

        // Periksa apakah nilai yang dipilih sudah ada dalam array data
        const data = this.state.dataAnswer;
        const existingItemIndex = data.findIndex(item => item.idpertanyaan === id);

        if (existingItemIndex !== -1) {
            // Perbarui item yang sudah ada
            const updatedData = [...data];
            updatedData[existingItemIndex].bobot = bobot;
            this.setState({ dataAnswer: updatedData });
        } else {
            // Tambahkan item baru ke dalam array data
            const newItem = { idpertanyaan: id, bobot: bobot };
            this.setState({
                dataAnswer: [
                    ...this.state.dataAnswer,
                    newItem
                ]
            })
        }
    }
    postAnswer = async (e) => {
        e.preventDefault();
        this.setState({ isLoading: true });

        const dataForm = {
            nim: this.props.dataMhs.nim,
            idjadwal: this.state.detailModal.idjadwal,
            idfakultas: this.props.dataMhs.idfakultas,
            ta: this.state.detailModal.ta,
            smtta: this.state.detailModal.smtta,
            semester: this.state.detailModal.semester,
            komentar: this.state.komentar,
            data: this.state.dataAnswer
        };

        try {
            const res = await postEval(dataForm, this.props.idjenis);
            if (res.status === 200) {
                this.props.refresh(e);
                this.closeModal.current.click();
                swal({
                    icon: 'success',
                    title: 'Berhasil',
                    text: 'Data telah disimpan'
                }).then(() => {
                    window.location.href = '/jadwal';
                });
            } else {
                throw new Error('Gagal menyimpan data');
            }
        } catch (error) {
            swal({
                icon: 'error',
                title: 'Gagal',
                text: 'Terjadi kesalahan saat menyimpan data. Silakan coba lagi.'
            });
        } finally {
            this.setState({ isLoading: false });
        }
    }


    render() {

        const dataPertanyaan = [...(this.state.detailModal.dataPertanyaan ?? []), ...(this.props.dataSarpras ?? [])]
        return (
            <div className="card card-custom">
                <div className="card-body">
                    <p className="card-title text-center mb-4" style={{ fontSize: '25px', marginTop: '10px' }}>Kuisioner Dosen</p>
                    <div className="table-responsive" id="">
                        <table id="" className="display expandable-table table-striped" style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Kode MK</th>
                                    <th>Mata Kuliah</th>
                                    <th>Kode Dosen</th>
                                    <th>Nama Dosen</th>
                                    <th>Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.data.length !== 0 ? this.props.data.map((list, i) => {
                                        return (
                                            <tr key={i} >
                                                <td>{i + 1}</td>
                                                <td>{list.kodemk}</td>
                                                <td>{list.matkul}</td>
                                                <td>{list.kddosen}</td>
                                                <td>{list.dosen}</td>
                                                <td>
                                                    {list.validasi == "BelumDiisi" ?
                                                        <button className="btn btn-primary"
                                                            data-toggle="modal"
                                                            data-target="#pertanyaan"
                                                            onClick={() => this.detailModal(list)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            Isi Evaluasi
                                                        </button>
                                                        :
                                                        <span className="badge badge-success"
                                                        >
                                                            Selesai
                                                        </span>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }) : <tr><td colSpan="8"><center>  Tidak ada data </center></td></tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    {/* Modal */}
                    <div className="modal fade" id="pertanyaan" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <form id="dataTambah" onSubmit={this.postAnswer}>
                            <div className="modal-dialog modal-xl" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title" id="exampleModalLabel">Pertanyaan </h4>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeModal} >
                                            <span aria-hidden="true" className="close-btn">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body" style={{ marginBottom: '-30px' }}>
                                        <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td width="200px">Kode Dosen</td>
                                                    <td width="5px"> : </td>
                                                    <td>{this.state.detailModal.kddosen}</td>
                                                </tr>
                                                <tr>
                                                    <td>Kode Matakuliah</td>
                                                    <td> : </td>
                                                    <td>{this.state.detailModal.kodemk}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div className="table-responsive mt-3" id="">
                                            <table id="" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                                <tbody>
                                                    {
                                                        dataPertanyaan.map((list, i) => {
                                                            return (
                                                                <Fragment key={i}>
                                                                    <tr>
                                                                        <td>{i + 1}. {list.pertanyaan}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='1' required /> <label>{list.bobot1}</label>
                                                                            <br />
                                                                            <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='2' required /> <label>{list.bobot2}</label>
                                                                            <br />
                                                                            <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='3' required /> <label>{list.bobot3}</label>
                                                                            <br />
                                                                            <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='4' required /> <label>{list.bobot4}</label>
                                                                            <br />
                                                                            <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='5' required /> <label>{list.bobot5}</label>
                                                                        </td>
                                                                    </tr>
                                                                </Fragment>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <input type='text' className="form-control" name="komentar" onChange={this.handleInput}
                                            placeholder="Komentar & Saran untuk Dosen / Sarpras" required />
                                    </div>
                                    <button style={{ zIndex: '999' }} type="submit" className="btn btn-add-modal" disabled={this.state.isLoading}>
                                        {this.state.isLoading ? "Loading..." : "Simpan"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div >
                    {/* end of modal  */}
                </div>
            </div>
        )
    }
}
